var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpectrum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1563",
    "data-name": "Rectangle 1563",
    width: 15.18,
    height: 15.112,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spectrum_of_Formality",
    "data-name": "Spectrum of Formality",
    transform: "translate(-591 -301.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(591 301.662)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31624",
    "data-name": "Group 31624",
    transform: "translate(598.41 308.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31623",
    "data-name": "Group 31623",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11981",
    "data-name": "Path 11981",
    d: "M7.585,4.425a1.4,1.4,0,1,0,1.4,1.4,1.4,1.4,0,0,0-1.4-1.4",
    transform: "translate(2.414 1.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11982",
    "data-name": "Path 11982",
    d: "M4.12,8.33a1.4,1.4,0,1,0,1.4,1.4,1.4,1.4,0,0,0-1.4-1.4",
    transform: "translate(1.061 3.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11983",
    "data-name": "Path 11983",
    d: "M4.12.521a1.4,1.4,0,1,0,1.4,1.4,1.4,1.4,0,0,0-1.4-1.4",
    transform: "translate(1.061 0.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11984",
    "data-name": "Path 11984",
    d: "M14.817,13.348H7.274a2.124,2.124,0,0,1-4.187,0H.362a.362.362,0,1,1,0-.723H3.087a2.124,2.124,0,0,1,4.187,0h7.544a.362.362,0,1,1,0,.723m0-5.429H12.092a2.124,2.124,0,0,1-4.187,0H.362a.362.362,0,0,1,0-.724H7.905a2.124,2.124,0,0,1,4.187,0h2.725a.362.362,0,0,1,0,.724m0-5.43H7.274a2.124,2.124,0,0,1-4.187,0H.362a.362.362,0,0,1,0-.724H3.087a2.124,2.124,0,0,1,4.187,0h7.544a.362.362,0,0,1,0,.724",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpectrum);
export default __webpack_public_path__ + "static/media/spectrum.d7c45b3863f443c0993e7ee90e0097ab.svg";
export { ForwardRef as ReactComponent };